import _ from 'lodash';
import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import { api } from "../utils";

export default function VendorTypeahead(props) {
  const [inputValue, setInputValue] = useState("");

  const loadItemOptions = (typedValue, callback) => {
    if (!typedValue || !typedValue.length || typedValue.length < 2) {
      return;
    }
    api
      .post("Reference/VendorTypeAhead", { Name: typedValue })
      .then((response) => callback(response.data.vendors))
      .catch(() => {
        toast.error("There was an error loading vendor information.");
        callback([]);
      });
  }

  return (
    <AsyncSelect
      classNamePrefix='serviceThreadSelect'
      loadOptions={loadItemOptions}
      onInputChange={(e) => setInputValue(e)}
      onChange={props.onChange}
      noOptionsMessage={() => (_.isNil(inputValue) || inputValue.length <= 1) ? "Start typing to search Vendors" : "No vendors found"}
      inputValue={inputValue}
      value={props.value}
      isDisabled={props.disabled}
      onFocus={props.onFocus}
      placeholder={props.placeholder || "Type the vendor number you are looking for"}
      isClearable
    />);
} 